export const REQ_STATUS_UNDEFINED = -1;
export const REQ_STATUS_PROCESSING = 0;
export const REQ_STATUS_SUCCESS = 1;
export const REQ_STATUS_FAIL = 2;
